import React from 'react';
import './Header.css'
import Navbar from '../Navbar/Navbar';


const Header = () => {
    return (
    <div>
        <Navbar></Navbar>
   </div>
    );
};

export default Header;